import { TrendingUp, BookOpen, Zap, Globe, Megaphone } from "@/components/icons";
import { BLOG_POSTS } from "@/content/blog";
import type { Post, ChangelogEntry, CategoryMeta } from "./types";

export const POSTS_PER_PAGE = 10;

export const CHANGELOG: ChangelogEntry[] = [
  { label: "API v3.2.0", date: "Mar 16", accent: false },
  { label: "API v3.1.5", date: "Mar 16", accent: false },
  { label: "Dashboard 2.4.1", date: "Mar 9", accent: false },
  { label: "Proxy Builder 2.1.0", date: "Mar 9", accent: false },
  { label: "Mobile Proxies 5.4.0", date: "Mar 6", accent: true },
  { label: "Mobile Proxies 5.4.2", date: "Mar 6", accent: true },
  { label: "Residential API 3.0", date: "Mar 6", accent: true },
  { label: "Dashboard 2.3.5", date: "Mar 6", accent: false },
  { label: "API v3.1.0", date: "Mar 3", accent: false },
  { label: "Proxy Builder 2.0.5", date: "Mar 3", accent: false },
];

export const ALL_POSTS: Post[] = BLOG_POSTS.map((post, index) => ({
  id: index + 1,
  featured: index === 0,
  category: post.category,
  title: post.title,
  excerpt: post.excerpt,
  author: post.author,
  authorInitial: post.authorInitial,
  date: post.date,
  readTime: post.readTime,
  href: `/blog/${post.slug}`,
  tags: post.tags,
}));

export const CATEGORIES = ["All", "Guide", "Tutorial", "Research", "AI", "Announcement"];

export const categoryMeta: Record<string, CategoryMeta> = {
  Guide: {
    color: "color-mix(in srgb, var(--foreground) 60%, transparent)",
    icon: <BookOpen size={12} />,
  },
  Tutorial: { color: "#5b8cff", icon: <Zap size={12} /> },
  Research: { color: "#f59e0b", icon: <TrendingUp size={12} /> },
  AI: { color: "#06b6d4", icon: <Globe size={12} /> },
  Announcement: { color: "#ec4899", icon: <Megaphone size={12} /> },
};

export function getCategoryColor(cat: string): string {
  return categoryMeta[cat]?.color ?? "color-mix(in srgb, var(--foreground) 60%, transparent)";
}
